import { render } from "./slide3.vue?vue&type=template&id=543ba377&scoped=true"
import script from "./slide3.vue?vue&type=script&lang=js"
export * from "./slide3.vue?vue&type=script&lang=js"

import "./slide3.vue?vue&type=style&index=0&id=543ba377&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543ba377"]])

export default __exports__